export const AVAST_SUPPORT_PHONE_MAP: StringMap = {
  GB: '448000321430',
  DE: '498001013815',
  FR: '33805542423',
  AU: '611800417836',
  NZ: '64800461302',
  BR: '558007620196',
  MX: '528002690181',
  IT: '39800147648',
  ES: '34900031433',
  NL: '318002929204',
  PL: '48800013019',
  CH: '41800000521',
  BE: '3280089479',
  SE: '4620980704',
  IE: '3531800900670',
  US: '1-855-741-4323',
};

export const AVG_SUPPORT_PHONE_MAP: StringMap = {
  GB: '448000324486',
  DE: '498000663311',
  FR: '33805542429',
  AU: '611800417842',
  NZ: '64800461296',
  BR: '558007620197',
  MX: '528004227733',
  IT: '39800147650',
  ES: '34900031019',
  NL: '318002354353',
  PL: '48800013039',
  CH: '41800000288',
  BE: '3280089481',
  SE: '46201408120',
  IE: '3531800900672',
};
export const PARTNER_SUPPORT_URL_MAP: StringMap = {
  avast_intl: 'https://support.avast.com/en-us/article/avast-secure-identity-faq/',
  avg_intl:
    'https://support.avg.com/SupportArticleView?l=en&urlName=avg-secure-identity-faq&q=secure+identity&supportType=home',
};

/** Avast Secure Identity partner support URL — DWM KB article  */
export const AVAST_SECURE_IDENTITY_SUPPORT_URL =
  'https://support.avast.com/en-us/article/avast-secure-identity-dark-web-monitoring';

export const AVAST_3_LEGAL_URL_MAP: StringMap = {
  AU: 'https://www.avast.com/en-au/identity-theft-insurance-policy',
  NZ: 'https://www.avast.com/en-nz/identity-theft-insurance-policy',
  DEFAULT: 'https://www.avast.com/legal',
};

export const countryCodeList: string[] = [
  'AU',
  'NZ',
  'BR',
  'MX',
  'JP',
  'FR',
  'US',
  'DE',
  'GB',
  'BE',
  'PL',
  'SE',
  'CH',
  'IE',
  'IT',
  'NL',
  'ES',
  'IN',
];

export const whiteLabelClientIds = {
  MONEYLION: 'moneylion',
  LENVO: 'lenovo',
  EFXAU: 'efxau',
  AVAST_INTL: 'avast_intl',
  AVAST3: 'avast3',
  AVG_INTL: 'avg_intl',
  PSSO: 'psso',
};

export const NORTON_TENANT_ID = 'de527324-05e3-46eb-a2a7-43ab29c1aff7';

export const clientsUsingAvast3Design = ['avast3']; // Should use avast3 client once setup

export const creditEnabledPartners: string[] = [whiteLabelClientIds.AVAST3];
